import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { AdHero } from "../../assets/images";
import { FAQ } from "../../constants/faq";
import { FAQS } from "..";

const Info: React.FC = () => {
  const [showFaq, setShowFaq] = React.useState(0);
  const options: {
    title: string;
  }[] = [
    {
      title: "Overview",
    },
    {
      title: "Get Started",
    },
    {
      title: "Tips",
    },
    {
      title: "Help",
    },
  ];

  const features: {
    title: string;
    description: string;
  }[] = [
    {
      title: "Create brand new ads",
      description:
        "Select campaign parameters, such as an advertising objective, to fit your business goals. You can also manage creative work: upload your ad creative, write ad copy and review how your ads look on different devices",
    },
    {
      title: "Create brand new ads",
      description:
        "Select campaign parameters, such as an advertising objective, to fit your business goals. You can also manage creative work: upload your ad creative, write ad copy and review how your ads look on different devices",
    },
    {
      title: "Create brand new ads",
      description:
        "Select campaign parameters, such as an advertising objective, to fit your business goals. You can also manage creative work: upload your ad creative, write ad copy and review how your ads look on different devices",
    },
  ];

  const [active, setActive] = React.useState<string>("Overview");
  return (
    <div className="w-full bg-[#F6F7F9] ">
      <div className="w-[90%] flex justify-center pb-20  ">
        <div className="w-2/5 py-16 ">
          <div className="flex flex-col gap-8 w-[60%] ml-auto ">
            {options.map((item, index) => (
              <p
                className={` text-[20px] leading-6 text-left font-Poppins font-medium cursor-pointer hover:text-black pb-5 border-b border-[#949494]  ${
                  active === item.title ? "text-black" : "text-[#555]"
                }`}
                onClick={() => setActive(item.title)}
                key={index}
              >
                {item.title}
              </p>
            ))}
          </div>
        </div>
        <div className="w-3/5 py-16 pl-5 border-l border-[#949494]">
          {active === "Overview" && (
            <div className="flex flex-col gap-14 ">
              <div className="flex gap-10 items-center  ">
                <div className="flex flex-col gap-3 w-[55%]">
                  <p className="text-black font-Poppins text-28px font-semibold leading-10">
                    What is Ads Manager?
                  </p>
                  <span className="text-[#555] font-Poppins text-[12px] font-normal leading-4">
                    Ads manager is your starting point for running ads on
                    EcoMoto. Its an all in one tool for creating ads, managing
                    and track their advertising campaigns on the EcoMoto
                    platform.Ads Manager is a tool provided by Facebook that
                    allows businesses and advertisers to create, manage and
                    track their advertising campaigns on the Facebook platform.
                    It is a web-based platform that provides a range of features
                    and tools for creating and targeting ads, setting budgets
                    and bids, tracking ad performance, and optimizing campaigns
                    for better results.
                  </span>
                  <span className="text-[#555] font-Poppins text-[12px] font-normal leading-4">
                    With Ads Manager, businesses can choose from a variety of ad
                    formats, including image ads, video ads, carousel ads, and
                    more. They can also target their ads to specific audiences
                    based on demographics, interests, behaviors, and other
                    factors. Ads Manager provides detailed analytics and
                    reporting, allowing advertisers to track the performance of
                    their campaigns and make data-driven decisions to improve
                    their results. Overall, Ads Manager is a powerful tool that
                    enables businesses of all sizes to advertise on Facebook and
                    reach their target audience more effectively.
                  </span>
                  <span className="text-[#555] font-Poppins text-[12px] font-normal leading-4">
                    Overall, Ads Manager is a powerful tool that enables
                    businesses of all sizes to advertise on Facebook and reach
                    their target audience more effectively.
                  </span>

                  <div className="">
                    <button
                      type="button"
                      className="flex gap-5 bg-midGreen border rounded-lg p-5 font-Poppins text-[14px] font-semibold leading-5 items-center justify-center text-white "
                    >
                      Go to Ads Manager
                      <span>
                        <BsArrowRightShort size={20} color="white" />
                      </span>
                    </button>
                  </div>
                </div>
                <img src={AdHero} className="w-[40%] object-cover" alt="" />
              </div>
              <div className="flex flex-col gap-5">
                <p className="text-black font-Poppins text-[28px] font-semibold leading-10">
                  Key Features
                </p>
                <div className="w-full flex flex-shrink-0 flex-wrap justify-between gap-8">
                  {features.map((item, index) => (
                    <div
                      className="w-[45%] flex flex-col gap-[30px] p-10 bg-white border rounded-md hover:shadow-xl shadow-midGreen "
                      key={index}
                    >
                      <div className="flex flex-col gap-[10px]">
                        <p className="text-black font-Poppins text-[20px] font-semibold leading-8">
                          {item.title}
                        </p>
                        <p className="text-[#555] font-Poppins text-[12px] font-normal leading-4">
                          {item.description}
                        </p>
                      </div>
                      <p className="text-[#555555] font-Poppins text-[12px] font-normal leading-5 flex gap-2 cursor-pointer">
                        Learn more
                        <span>
                          <BsArrowRightShort size={20} color="#555555" />
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {active === "Get Started" && (
            <div className="flex flex-col gap-14">
              <p className="text-black font-Poppins font-[28px] leading-10">
                Quick Start Guide
              </p>
              <div className="flex flex-col p-10 bg-white shadow-md shadow-midGreen">
                <p className="text-[#3F3E3E] font-Poppins font-semibold font-[25px] leading-6  ">
                  Getting started with Ecomoto ads manager
                </p>

                <ol className="flex-col gap-10 list-item list-decimal ">
                  <li className="text-[#555] font-Poppins font font-normal ">
                    Lörem ipsum lys plangen ande pudiheten pölande. Disk nysegon
                    tevis kagåde och myren. Sal krovås hemineren hössade,
                    paheten. Polypp kaling agådade spedöpusm traren. Döde
                    pinysk. Fonoosmos missmatchning.
                  </li>
                  <li className="text-[#555] font-Poppins font font-normal ">
                    Lörem ipsum lys plangen ande pudiheten pölande. Disk nysegon
                    tevis kagåde och myren. Sal krovås hemineren hössade,
                    paheten. Polypp kaling agådade spedöpusm traren. Döde
                    pinysk. Fonoosmos missmatchning.
                  </li>
                  <li className="text-[#555] font-Poppins font font-normal ">
                    Lörem ipsum lys plangen ande pudiheten pölande. Disk nysegon
                    tevis kagåde och myren. Sal krovås hemineren hössade,
                    paheten. Polypp kaling agådade spedöpusm traren. Döde
                    pinysk. Fonoosmos missmatchning.
                  </li>
                  <li className="text-[#555] font-Poppins font font-normal ">
                    Lörem ipsum lys plangen ande pudiheten pölande. Disk nysegon
                    tevis kagåde och myren. Sal krovås hemineren hössade,
                    paheten. Polypp kaling agådade spedöpusm traren. Döde
                    pinysk. Fonoosmos missmatchning.
                  </li>
                </ol>
              </div>
            </div>
          )}
          {active === "Tips" && (
            <div className="flex flex-col gap-14">
              <p className="text-black font-Poppins text-[28px] font-semibold leading-10">
                Try these tips to get the most of EcoMoto Ads manager
              </p>
            </div>
          )}
          {active === "Help" && (
            <div className="flex flex-col gap-14">
              <p className="text-black font-Poppins text-[28px] font-semibold ">
                Frequently Asked Questions
              </p>

              <div className="w-full flex flex-col gap-4 ">
                {FAQ.map((faq, index) => (
                  <FAQS
                    faq={faq}
                    index={index}
                    key={index}
                    showFaq={showFaq}
                    setShowFaq={setShowFaq}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Info;
